import { getRelativePath } from "base/shared/Utils";

const BASE_PATH = "/overview";

export const getOverviewPath = () => getRelativePath(BASE_PATH);

export const getTransactionsPath = () =>
  getRelativePath(`${BASE_PATH}/transactions`);
